import { render } from "./OcrTableWrap.vue?vue&type=template&id=908c05dc"
import script from "./OcrTableWrap.vue?vue&type=script&lang=js"
export * from "./OcrTableWrap.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__